import React from 'react';
import Title from '../../partials/title';
import ScrollAnimation from 'react-animate-on-scroll';

const EntryFee = () => {
    return (
        <ScrollAnimation animateIn="fadeInLeft" animateOnce={true} className="w3-container w3-content pt-8 pb-8 hind">
            <Title text="Entry Fee" className="black " />
            <p className="gray margin-top">$210 per team for qualifying events. There is however an Early Entry Discount ($20) for teams that register and make payment up to <b className="anton">14 days before the event</b>. After this period, the Regular Entry Fee will be assessed to registrations and payments made <b className="anton">13-9 days before the event</b>. For teams registering and/or making payment after the Regular Entry Period, there will be a Late Entry Fee assessed ($20). Guaranteed entry date is 6pm Monday before the event.</p>
            <p className="gray">After Monday, teams will only be accepted on a case by case basis. There might be some cases where the soccer facility fills up early, and applications will be cut off sooner than the above dates.</p>
            <p className="gray">For entry fees and deadlines for the Challenge Sports 3v3 Tour National Championships, please refer to <a href="#nationals" className="red underlined">the National Information page.</a></p>
        </ScrollAnimation>
    );
}

export default EntryFee;



// WEBPACK FOOTER //
// ./src/components/information/partials/entry_fee.js